import {Routes} from "@angular/router";
import {AuthComponent} from "../auth/auth.component";
import {AuthGuard} from "./auth.guard";
import {MainComponent} from "../main/main.component";

export const routes: Routes = [
    {
        path: 'auth',
        component: AuthComponent,
        loadChildren: '../auth/auth.module#AuthModule'
    },
    {
        path: '',
        component: MainComponent,
        loadChildren: '../main/main.module#MainModule',
        canActivate: [AuthGuard],
    },

    // otherwise redirect to home
    { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
];



// WEBPACK FOOTER //
// /code/frontend/src/app/core/routes.ts